<template>
  <div
    id="album"
    class="container"
    v-loading="floading"
    element-loading-background="transparent"
  >
    <section>
      <div class="row">
        <div class="col-lg-9 pr-lg-4 margin-bottom">
          <!-- 類型 -->
          <div class="album-category section-group">
            <h2 class="section-title">{{$t('Album.albumIndex.type')}}</h2>
            <div class="row">
              <div class="" v-for="(type) in albumTypeList" :key="type.id">
                <div class="album-subtitle-category mb-2">
                  <router-link
                    class="image_tag"
                    v-bind:to="{
                      name: 'albumList',
                      query: {
                        SGL_PG_CMasterSort: type.id,
                      },
                    }"
                  >
                    <div
                      class="image_tag_image"
                      :style="{
                        backgroundImage: 'url(' + type.sgL_ImageUrl + ')',
                      }"
                    ></div>
                    <div class="image_tag_title">
                      {{ type.sgL_NewName }}
                    </div>
                  </router-link>
                  <!-- <router-link
                    v-bind:to="{
                      name: 'albumList',
                      query: {
                        id: type.id,
                      },
                    }"
                  >
                    <div class="album-category-block">
                      <div class="album-category-thumbnail">
                        <div class="album-category-responsive">
                          <div class="album-category-sizer">
                            <div
                              class="album-category-image"
                              :style="{
                                backgroundImage:
                                  'url(' + type.sgL_ImageUrl + ')',
                              }"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="album-category-title" :title="type.sgL_NewName">
                      {{ type.sgL_NewName }}
                    </div>
                  </router-link> -->
                </div>
              </div>
            </div>
          </div>

          <!-- Album Category (mobile) -->
          <section class="m-album-category">
            <div class="section-title">{{$t('Album.albumIndex.type')}}</div>
            <div class="m-wrap-list">
              <ul class="m-list-wrapper">
                <li
                  class="m-list-item"
                  v-for="(type) in albumTypeList"
                  :key="type.id"
                >
                  <div class="album-category-card mb-2">
                    <router-link
                      v-bind:to="{
                        name: 'albumList',
                        query: {
                          SGL_PG_CMasterSort: type.id,
                        },
                      }"
                    >
                      <div class="album-category-block">
                        <div class="album-category-thumbnail">
                          <div class="album-category-responsive">
                            <div class="album-category-sizer">
                              <div
                                class="album-category-image"
                                :style="{
                                  backgroundImage:
                                    'url(' + type.sgL_ImageUrl + ')',
                                }"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        :title="type.sgL_NewName"
                        class="album-category-title"
                      >
                        {{ type.sgL_NewName }}
                      </div>
                    </router-link>
                  </div>
                </li>
              </ul>
            </div>
          </section>
          <!-- ./Album Category (mobile) -->

          <!-- /.類型 -->

          <!-- 本週熱門 -->
          <div class="hot-album section-group">
            <h2 class="section-title">
              {{$t('Album.albumIndex.Hot')}}

              <router-link class="section-more" :to="{ name: 'albumList' }"
                > {{$t('Album.albumIndex.more')}}
              </router-link>
            </h2>
            <div class="row">
              <div
                class="col-6 col-md-3"
                v-for="hot in albumHotList"
                :key="hot.id"
              >
                <div class="album-card card m-0">
                  <router-link
                    :to="{
                      name: 'albumviewPhotostream',
                      query: { id: hot.id },
                    }"
                  >
                    <div class="album-block">
                      <div class="album-thumbnail">
                        <div class="album-responsive">
                          <div class="album-sizer">
                            <div
                              class="album-image"
                              :style="{
                                backgroundImage: 'url(' + hot.photoImage + ')',
                              }"
                            ></div>
                          </div>
                        </div>
                        <div class="album-photo-count">
                          <span>{{ hot.sgL_PG_CPhotoQuantityF }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="album-info p-3">
                      <div class="album-title mb-2" :title="hot.sgL_PG_CName">
                        {{ hot.sgL_PG_CName }}
                      </div>
                      <span class="album-user">{{
                        hot.sgL_Mem_DisplayName
                      }}</span>
                      <span class="album-upload-date">{{
                        hot.sgL_PG_CAddTimerI
                      }}</span>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <!-- /.本週熱門 -->

          <!-- 廣告 -->
          <!-- <div class="row">
            <div class="col-12">
              <div class="ad section-group py-4">
                <ins
                  class="adsbygoogle"
                  style="display: inline-block; width: 300px; height: 250px"
                  data-ad-client="ca-pub-8370308321819212"
                  data-ad-slot="7350126089"
                ></ins>
              </div>
            </div>
          </div> -->

          <!-- ./廣告 -->

          <!-- 最新上傳 -->
          <div class="latest-album section-group">
            <h2 class="section-title">
              {{$t('Album.albumIndex.Latestupload')}}
              <router-link class="section-more" :to="{ name: 'albumList' }"
                >{{$t('Album.albumIndex.more')}}
              </router-link>
            </h2>
            <div class="row">
              <div
                class="col-6 col-md-4 col-lg-3"
                v-for="latest in albumLatest"
                :key="latest.id"
              >
                <div class="album-card card">
                  <router-link
                    :to="{
                      name: 'albumviewPhotostream',
                      query: { id: latest.id },
                    }"
                  >
                    <div class="album-block">
                      <div class="album-thumbnail">
                        <div class="album-responsive">
                          <div class="album-sizer">
                            <div
                              class="album-image"
                              :style="{
                                backgroundImage:
                                  'url(' + latest.photoImage + ')',
                              }"
                            ></div>
                          </div>
                        </div>
                        <div class="album-photo-count">
                          <span>{{ latest.sgL_PG_CPhotoQuantityF }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="album-info p-3">
                      <div
                        class="album-title mb-2"
                        :title="latest.sgL_PG_CName"
                      >
                        {{ latest.sgL_PG_CName }}
                      </div>
                      <span class="album-user">{{
                        latest.sgL_Mem_DisplayName
                      }}</span>
                      <span class="album-upload-date">{{
                        latest.sgL_PG_CAddTimerI
                      }}</span>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <!-- /.最新上傳 -->
        </div>
        <div class="col-lg-3 mt-lg-5">
          <!-- 上傳相片  -->
          <div class="section-group btn-fixed">
            <el-button
              type="primary"
              icon="fa fa-cloud-upload-alt fa-fw fa-sm mr-1"
              class="btn btn-block btn-primary"
              @click="uploadImage()"
              >{{$t('Album.albumIndex.Uploadphotos')}}</el-button
            >
          </div>
          <!-- ./上傳相片 -->

          <!-- 廣告 -->
          <div class="ad section-group">
            <div class="row">
              <div class="col-12">
                <ins
                  class="adsbygoogle"
                  style="display: inline-block; width: 300px; height: 250px"
                  data-ad-client="ca-pub-8370308321819212"
                  data-ad-slot="7350126089"
                ></ins>
              </div>
            </div>
          </div>

          <!-- ./廣告 -->
          <div class="section-group">
            <div class="row">
              <div class="col-12">
                <h2 class="section-title">
                  {{$t('Album.albumIndex.Ranking')}}
                  <router-link class="section-more" :to="{ name: 'VRanking' }">
                    {{$t('Album.albumIndex.more')}}
                  </router-link>
                </h2>
                <div class="collection-list card">
                  <div class="card-body">
                    <table class="table">
                      <thead>
                        <tr>
                          <th class="collection-album-count" scope="col">
                            {{$t('Album.albumIndex.Ranking_')}}
                          </th>
                          <th
                            class="collection-list-title"
                            scope="col"
                            style="text-align: center"
                          >
                          {{$t('Album.albumIndex.photographer')}}
                          </th>
                        </tr>
                      </thead>
                      <tbody class="collection">
                        <tr
                          v-for="(item, ix) in pmList"
                          :key="item.id"
                          @click="
                            $router.push({
                              name: 'customerPublishLook',
                              query: { authorId: item.sgl_mem_cid },
                            })
                          "
                        >
                          <td class="collection-album-count">
                            {{ ix + 1 }}
                          </td>
                          <td
                            class="collection-list-title"
                            style="text-align: center"
                          >
                            {{ item.sgL_Mem_DisplayName }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 本週合集 -->
          <div class="section-group">
            <div class="row">
              <div class="col-12">
                <h2 class="section-title">
                  {{$t('Album.albumIndex.Collection')}}
                  <router-link
                    class="section-more"
                    :to="{ name: 'collectionlist' }"
                  >
                  {{$t('Album.albumIndex.more')}}
                  </router-link>
                </h2>
                <div class="collection-list card">
                  <div class="card-body">
                    <table class="table">
                      <thead>
                        <tr>
                          <th class="collection-list-title" scope="col">
                            {{$t('Album.albumIndex.Compilationtitle')}}
                          </th>
                          <th class="collection-album-count" scope="col">
                            {{$t('Album.albumIndex.Numberalbums')}}
                          </th>
                        </tr>
                      </thead>
                      <tbody class="collection">
                        <tr
                          v-for="item in hjList"
                          :key="item.id"
                          @click="toHJDetail(item.id)"
                        >
                          <td class="collection-title">
                            {{ item.sgL_PhotoName }}
                          </td>
                          <td class="collection-album-count">
                            {{ item.sgL_PhotoalbumCount }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ./本週合集 -->
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { param } from "jquery";
export default {
  data() {
    return {
      albumTypeList: null,
      albumHotList: null,
      albumLatest: null,
      albumWeekList: null,
      floading: true,
      hjList: null,
      pmList: [],
    };
  },
  created() {
    this.$store.dispatch("updateCurrentIndex", 4);
    this.$store.dispatch("getCommonTypeDesk", 70).then((res) => {
      this.albumTypeList = res; //相簿類型
    });

    this.getHotWeek();
    this.getpmData();
    this.getLatestAlbum();
    this.gethjData();
  },
  methods: {
    toHJDetail(id) {
      this.$router.push({
        name: "collection",
        query: { id },
      });
    },
    getpmData() {
      this.$api.albumApi.GetVRanking(null).then((res) => {
        if (res.data.success) {
          this.pmList = res.data.result
            .filter((c) => c.t === "SGL_PG_CViewQuantity")
            .slice(0, 5);
        }
      });
    },
    gethjData() {
      var today = new Date();
      var end = this.$api.commons.format(today, "YYYY-MM-DD");
      var oneday = 1000 * 60 * 60 * 24;
      var begindate = new Date(today - oneday * 14);
      var begin = this.$api.commons.format(begindate, "YYYY-MM-DD");
      let params = {
        createTime: [begin, end],
      };
      this.$api.albumApi.PhotoCollectionGetAll(params).then((res) => {
        if (res.data.success) {
          this.hjList = res.data.result.items;
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
    },
    getHotWeek() {
      var today = new Date();

      var end = this.$api.commons.format(today, "YYYY-MM-DD");

      var oneday = 1000 * 60 * 60 * 24;

      var begindate = new Date(today - oneday * 7);

      var begin = this.$api.commons.format(begindate, "YYYY-MM-DD");

      let params = {
        SGL_AddTimerDate: [begin, end],
        SGL_PG_CPublicshare: true,
        SkipCount: 0,
        Sorting: "QueriesCount",
        MaxResultCount: 4,
      };
      this.$api.albumApi.GetalbumHotWeek(params).then((res) => {
        if (res.data.success) {
          this.albumHotList = res.data.result.items;
        }
      });
    },
    uploadImage() {
      this.$router.push({ name: "uploadImage" });
    },
    getLatestAlbum() {
      let params = {
        SGL_PG_CPublicshare: true,
        SkipCount: 0,
        MaxResultCount: 8,
        Sorting: "CreateTime",
      };
      this.$api.albumApi.GetalbumHotWeek(params).then((res) => {
        if (res.data.success) {
          this.floading = false;
          this.albumLatest = res.data.result.items;
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Album/albumIndex.vue